import { FullTableState } from '../app/store/common/app.reducer';

export function createDefaultTableState(factory?: string): FullTableState {
  return {
    first: 0,
    rows: 25,
    sortField: '',
    sortOrder: 1,
    filters: {
      factory: {
        value: factory || '',
        matchMode: 'startsWith',
      },

      equipmentType: {
        value: null,
        matchMode: 'contains',
        operator: 'and',
      },

      equipmentReference: {
        value: null,
        matchMode: 'contains',
        operator: 'and',
      },

      context: {
        value: '',
        matchMode: 'contains',
        operator: 'and',
      },

      ruleState: {
        value: 'healthy',
        matchMode: 'startsWith',
      },

      alarm: {
        value: 'active',
        matchMode: 'startsWith',
        operator: 'and',
      },
    },
    globalFilter: '',
  };
}

export function getUniqueOptions<T extends keyof any>(data: any[], key: T) {
  return Array.from(new Set(data.map((e) => e?.[key]).filter(Boolean))).map(
    (val) => ({ label: val, value: val })
  );
}

export function calculateAlarmCount(rules: any[]): number {
  const now = new Date();
  const todayMidnightUTC = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  );

  return rules.filter((rule) => {
    const startDate = new Date(rule?.latestAlarm?.startDate);
    return startDate.getTime() > todayMidnightUTC.getTime();
  }).length;
}
